/**
 * Settings Store Module
 *
 * Load Tablet Settings
 */

// Dependencies
import Vue from 'vue'

// Types
import * as types from '@/lib/store/types'

// Constants
const defaults = {
	tabletId: null,
	isMaster: false,
}
const storageKey = 'settings'

// State
const state = {
	settings: JSON.parse(localStorage.getItem(storageKey)) || defaults,
}

const actions = {
	[types.UPDATE_SETTINGS]({ commit }, data) {
		commit(types.SET_SETTINGS, data)
	},

	[types.RESET_SETTINGS]({ commit }) {
		commit(types.SET_SETTINGS, defaults)
	},
}

const mutations = {
	[types.SET_SETTINGS](state, data) {
		localStorage.setItem(storageKey, JSON.stringify(data))
		Vue.set(state, 'settings', data)
	},
}

const getters = {
	settings: state => state.settings,
}

export default {
	state,
	actions,
	mutations,
	getters,
}



// WEBPACK FOOTER //
// ./src/lib/store/modules/Settings.js